import { render } from "./Debug.vue?vue&type=template&id=ae4c9e32"
import script from "./Debug.vue?vue&type=script&lang=ts"
export * from "./Debug.vue?vue&type=script&lang=ts"
script.render = render

export default script